import {
  Module,
  PATH_CONTRACTOR_CARDS,
  PATH_CONTRACTOR_VISITS,
  PATH_ROOT,
} from "@/constants";
import { cn } from "@/lib/utils";
import { usePermissions } from "@/modules/account/hooks/usePermissions";
import { FileText, FileUser, HomeIcon } from "lucide-react";
import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MobileFooterButton } from "./MobileFooterButton";
import { MobileNavigationSheet } from "./MobileNavigationSheet";
import { NavigationAnchor } from "../types";
import { useIsAdmin } from "@/modules/account/hooks/useIsAdmin";
import { useIsActiveContractor } from "@/modules/account/hooks/useIsActiveContractor";

interface MobileFooterProps {
  className?: string;
}

export const MobileFooter = memo(({ className }: MobileFooterProps) => {
  const permissions = usePermissions();
  const { t } = useTranslation();
  const isContractorActive = useIsActiveContractor();
  const isAdmin = useIsAdmin();
  const hideContractorItems = !(isAdmin || isContractorActive);

  const navigationItems = useMemo<NavigationAnchor[]>(
    () =>
      [
        {
          icon: HomeIcon,
          url: PATH_ROOT,
          permission: true,
          title: t("breadcrumb.home"),
        },
        {
          icon: FileUser,
          url: PATH_CONTRACTOR_VISITS,
          permission: permissions[Module.ContractorPanelVisits].can_read,
          hide: hideContractorItems,
          title: t("navigation.contractorVisitsPanel"),
        },
        {
          icon: FileText,
          url: PATH_CONTRACTOR_CARDS,
          permission: permissions[Module.ContractorPanelCards].can_read,
          hide: hideContractorItems,
          title: t("navigation.myContractorCards"),
        },
      ].filter((item) => !item.hide),
    [permissions, t, hideContractorItems],
  );

  return (
    <menu
      className={cn("flex gap-2 w-full justify-center items-center", className)}
    >
      {navigationItems.map((props) => (
        <li className="shrink-0 grow-0 w-16">
          <MobileFooterButton {...props} />
        </li>
      ))}
      <li className="shrink-0 grow-0 w-16">
        <MobileNavigationSheet />
      </li>
    </menu>
  );
});
